import React from 'react';
import PropTypes from 'prop-types';

import { CallToActionSection } from './CallToActionSection';
import { NumberedItem } from './NumberedItem';
import { LinkV2 } from '../LinkV2';

import './HowItWorksSectionV2.css';

export const HowItWorksSectionV2 = ({
  children,
  largeImage,
  smallImage,
  numberedList,
  howItWorksTitle,
  howItWorksCTACopy,
  howItWorksCTAUrl,
  howItWorksBackgroundColor,
  displayPlayIcon,
  displayTitleOnTop = true,
  centerButtons = true,
  onImageClick,
  component: Component = 'section',
  onCtaClick,
  imgAlt = 'How Zola Registry works video placeholder',
  ...props
}) => {
  const renderNumberedItem = () => {
    return numberedList.map((item, index) => (
      <NumberedItem
        number={index + 1}
        key={index}
        title={item.title}
        numberColor="teal"
        titleColor="navy"
        bodyCopyColor="primaryGray"
      >
        {item.description}
      </NumberedItem>
    ));
  };

  const renderButtons = ({ larger }) => {
    return (
      <>
        {howItWorksCTACopy && (
          <LinkV2
            href={howItWorksCTAUrl}
            sizes={larger ? 'regular' : 'inherit'}
            arrow
            onClick={onCtaClick}
          >
            {howItWorksCTACopy}
          </LinkV2>
        )}
      </>
    );
  };

  const renderImageContainer = (image) => (
    <div className="how-it-works-section__image-container" onClick={onImageClick}>
      <img className="how-it-works-section__image" src={image} alt={imgAlt} loading="lazy" />
      {displayPlayIcon && (
        <span
          aria-hidden="true"
          className="how-it-works-section__modal-icon zola-ui-icon zola-ui-icon-play"
        />
      )}
    </div>
  );

  return (
    <Component className="how-it-works-section" {...props}>
      <section className="how-it-works-section-mobile">
        <h2 className="how-it-works-section__title zui__h2">{howItWorksTitle}</h2>
        {renderImageContainer(smallImage)}
        <div className="numbered-items__container">{renderNumberedItem()}</div>
        {renderButtons({ larger: false })}
      </section>
      <section className="how-it-works-section-regular">
        <CallToActionSection
          component="div"
          backgroundColor={howItWorksBackgroundColor}
          title={howItWorksTitle}
          height="auto"
          headerTag="h2"
          text={
            <div className="how-it-works-section__list">
              <div className="numbered-items__container">{renderNumberedItem()}</div>
            </div>
          }
          secondaryRight
          secondaryContents={renderImageContainer(largeImage)}
          smallerTitle
          buttons={renderButtons({ larger: true })}
          heroTitleAlwaysOnTop={displayTitleOnTop}
          centerButtonsOnMobile={centerButtons}
        />
      </section>
    </Component>
  );
};

HowItWorksSectionV2.propTypes = {
  largeImage: PropTypes.string,
  smallImage: PropTypes.string,
  displayPlayIcon: PropTypes.bool,
  centerButtons: PropTypes.bool,
  displayTitleOnTop: PropTypes.bool,
  howItWorksTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  howItWorksCTACopy: PropTypes.string,
  howItWorksCTAUrl: PropTypes.string,
  component: PropTypes.oneOf(['div', 'section']),
  numberedList: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
      description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    })
  ),
  howItWorksBackgroundColor: PropTypes.oneOf(['white', 'lightGray']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onImageClick: PropTypes.func,
  larger: PropTypes.bool,
  onCtaClick: PropTypes.func,
  imgAlt: PropTypes.string,
};

export default HowItWorksSectionV2;
